import SimpleTableFilterDropdown from './SimpleTableFilterDropdown';

export default SimpleTableFilterDropdown;
